import { render, staticRenderFns } from "./DomainPageCard.vue?vue&type=template&id=6257a1dc"
import script from "./DomainPageCard.vue?vue&type=script&lang=js"
export * from "./DomainPageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports